import type { TFunction } from 'i18next'

// NOTE: this issue will be fixed once converted to ui library
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ModalPortal } from '@cash-web/shared-feature-modal'

import QRContent, { type Props as QRContentProps } from '../QRContent'

export type Props = {
  open?: boolean
  onClose: () => void
  /** I18next translation function*/ t: TFunction
} & QRContentProps

interface IqrHashes {
  [string: string]: string
}

export const qrHashes: IqrHashes = {
  chat: '#chat',
}

// Note: I am moving the 'open' prop in here as I would like to nicely animate this in the future
export default function QRModal({ open = false, onClose, t, ...qrProps }: Props) {
  return open ? (
    <ModalPortal
      ariaLabel={t('Chat with us', { context: 'title for qr with link to chat with us ' })}
      closeButtonProps={{ onClose }}
    >
      <QRContent {...qrProps} />
    </ModalPortal>
  ) : null
}
